import { Select, colors } from '@insurancemenu/imenu-components-lib';
import { ChevronWrapperStyled } from '@insurancemenu/imenu-components-lib/dist/components/Select/styles';
import { css, CSSProp, styled } from 'styled-components';

export const InterestSelectStyled = styled(Select)<{ $isDisabled: boolean }>`
  /* Only the container is styled, not the select element */
  & select {
    border: 0.1rem solid ${colors.neutral[300]};
    ${({ $isDisabled }): string =>
      $isDisabled
        ? `
      background-color: ${colors.neutral.white};
    `
        : ''}
  }

  /* Hide chevron icon when disabled */
  ${({ $isDisabled }): CSSProp =>
    $isDisabled
      ? css`
          & ${ChevronWrapperStyled}::after {
            display: none;
          }
        `
      : ''}
`;
